/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://app-settings.fitbitdevelopercontent.com/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(255);


/***/ }),

/***/ 58:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(141);
	var objectAssign = __webpack_require__(58);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),

/***/ 141:
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _queryString = __webpack_require__(138);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var handleRequest = function handleRequest(url, params) {
	  var stateParams = _queryString2.default.parse(url.search);
	
	  url.search = _queryString2.default.stringify(Object.assign({}, stateParams, params));
	
	  window.location = url.toString();
	};
	
	var parseParamString = function parseParamString(paramString) {
	  var _queryString$parse = _queryString2.default.parse(paramString),
	      queryState = _queryString$parse.state,
	      params = _objectWithoutProperties(_queryString$parse, ['state']);
	
	  var state = void 0;
	
	  // Decode urlsafe base64
	  if (/^b64/.test(queryState)) {
	    state = atob(queryState.replace(/^b64/, '').replace(/-/g, '+').replace(/_/g, '/'));
	  } else {
	    state = queryState && decodeURIComponent(queryState);
	  }
	
	  return {
	    state: state,
	    params: params
	  };
	};
	
	var parseState = function parseState(state) {
	  if (!state) {
	    return {};
	  }
	
	  var fullState = void 0;
	  try {
	    fullState = JSON.parse(state);
	  } catch (err) {
	    fullState = {
	      callbackUrl: state
	    };
	  }
	
	  return fullState;
	};
	
	// Gallery debugger callback url
	// Handle fitbit.com urls
	var HTTP_PROTOCOL_REGEX = /^https?:$/;
	var FITBIT_URL_REGEX = /.*\.fitbit.com$/;
	
	// Android Webconfig callback url
	// Source reference: https://source.fitbit.com/projects/ANDROID/repos/fitbitandroid/browse/platform/src/main/java/com/fitbit/platform/domain/AppSettingsContext.java
	// Example: intent://appid/buildid/encodeddeviceid#Intent;scheme=fitbit;package=com.fitbit.FitbitMobile;end
	var ANDROID_INTENT_HASH_REGEX = /^#Intent;scheme=fitbit;package=com\.fitbit\.(?:[a-zA-Z]+\.)?(FitbitMobile|dogebit)(?:\.[a-zA-Z]+)?;end$/;
	
	// iOS Webconfig callback url
	// Source reference: https://source.fitbit.com/projects/IOS/repos/fitbit/browse/Frameworks/JSbitKit/JSbitKit/Admin/WebconfigCallbackURLResponse.swift
	// Example: fitbit://gallery/webconfig/appid/buildid/encodeddeviceid
	var IOS_URL_REGEX = /^(?:dev|beta|fit|alpha|debug|dog|internal)bit(-cn)?:\/\/gallery\/webconfig\/.*$/;
	
	var isValidCallbackUrl = function isValidCallbackUrl(_ref) {
	  var protocol = _ref.protocol,
	      host = _ref.host,
	      href = _ref.href,
	      hash = _ref.hash;
	
	  if (HTTP_PROTOCOL_REGEX.test(protocol) && FITBIT_URL_REGEX.test(host) && hash === '#gallery-debugger') {
	    return true;
	  }
	
	  if (protocol === 'intent:' && ANDROID_INTENT_HASH_REGEX.test(hash)) {
	    return true;
	  }
	
	  if (IOS_URL_REGEX.test(href)) {
	    return true;
	  }
	
	  return false;
	};
	
	var handleError = function handleError(url) {
	  var root = document.getElementById('root');
	  root.innerText = 'Invalid callback url ' + url;
	};
	
	(function () {
	  var _parseParamString = parseParamString(window.location.hash || ''),
	      hashState = _parseParamString.state,
	      hashParams = _parseParamString.params;
	
	  var _parseParamString2 = parseParamString(window.location.search || ''),
	      queryState = _parseParamString2.state,
	      queryParams = _parseParamString2.params;
	
	  var state = hashState || queryState;
	
	  var params = Object.assign({}, hashParams, queryParams);
	
	  var _parseState = parseState(state),
	      callbackUrl = _parseState.callbackUrl,
	      stateParams = _objectWithoutProperties(_parseState, ['callbackUrl']);
	
	  if (!callbackUrl) {
	    handleError('');
	    return;
	  }
	
	  var parsedUrl = new URL(callbackUrl);
	
	  if (!isValidCallbackUrl(parsedUrl)) {
	    handleError(callbackUrl);
	    return;
	  }
	
	  if (Object.keys(stateParams).length > 0) {
	    params.state = encodeURIComponent(JSON.stringify(stateParams));
	  }
	
	  handleRequest(parsedUrl, params);
	})();

/***/ })

/******/ });


// WEBPACK FOOTER //
// static/js/simple-redirect.f439d1b6cb8c02599c12265bdc6d5fb8.js